import * as React from 'react';

interface IProps {
    resultCountText: string;
    totalResults: number;
}

export class ResultCount extends React.Component<IProps, any> {

    render() {
        return (
            <div className="pagination-count" dangerouslySetInnerHTML={{ __html: this.getDisplayText() }} aria-live="polite"></div>
        )
    }

    getDisplayText = () => {
        return this.props.resultCountText && this.props.resultCountText.replace("{{RESULTCOUNT}}", this.props.totalResults.toString());
    }
}

